import React from "react";
import { useLocation } from "react-router-dom";

const urlBannerList = [
  {
    id: 1,
    name: "Dashboard",
    url: "/admin",
    bannerUrl: "/Images/header-banners/dashboardBanner.jpg",
    desc: "View and manage all items in site",
  },
  {
    id: 9,
    name: "Events",
    url: "/events",
    bannerUrl: "/Images/eventBanner.jpg",
    desc: "View Current Events and Register",
  },
  {
    id: 10,
    name: "My Reservations",
    url: "/myreserved",
    bannerUrl: "/Images/header-banners/myreservedBanner.jpg",
    desc: "View your event reservations",
  },
  {
    id: 11,
    name: "My Orders",
    url: "/myorders",
    bannerUrl: "/Images/header-banners/myordersBanner.jpg",
    desc: "View and manage your orders",
  },
  {
    id: 12,
    name: "Account Information",
    url: "/myprofile",
    bannerUrl: "/Images/eventBanner.jpg",
    desc: "Manage your account information",
  },
  {
    id: 13,
    name: "My Certifications",
    url: "/mycertifications",
    bannerUrl: "/Images/header-banners/mycertificationsBanner.jpg",
    desc: "View your awarded certifications",
  },
  {
    id: 14,
    name: "Check-In",
    url: "/checkin",
    bannerUrl: "/Images/header-banners/checkinBanner.jpg",
    desc: "Check in to your event",
  },
];

const Banner = (props) => {
  const urlObj = useLocation();
  const currentBanner = urlBannerList.find(
    ({ url }) => url === urlObj.pathname
  );

  const bgImageStyle = {
    backgroundImage: `url(${currentBanner?.bannerUrl})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  };

  return currentBanner ? (
    <div
      id="banner"
      className="full-row"
      style={currentBanner?.bannerUrl ? bgImageStyle : {}}
    >
      <div className="overlay"></div>
      <div className="banner-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 text-white">
              <h1 className="text-uppercase">{currentBanner?.name}</h1>
              <p>{currentBanner?.desc}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};
export default Banner;
